export const endocrinologyConst = {
  path: "/single-programs/endocrinology",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ – ЭНДОКРИНОЛОГИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> бакалавра, магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Эндокринология — образование, которое восстанавливает баланс жизни</h2>
      <p>Эндокринология — это ключевое направление медицины, изучающее работу гормональной системы человека.</p>
      <p>
        Специалисты в этой области помогают людям с диабетом, ожирением, нарушениями щитовидной железы, репродуктивными и метаболическими
        расстройствами.
      </p>
      <p>
        Обучаясь на факультете медицины по направлению "Эндокринология", вы получаете как фундаментальные медицинские знания, так и
        специализированную подготовку, необходимую для диагностики, профилактики и лечения эндокринных заболеваний.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Физиология и патология эндокринной системы</li>
        <li>Диабетология и ожирение</li>
        <li>Гормональные исследования и лабораторная диагностика</li>
        <li>Медицинская генетика и молекулярная биология</li>
        <li>Лечение метаболических синдромов</li>
        <li>Иммунология и аутоиммунные процессы</li>
        <li>Клиническая фармакология гормональных препаратов</li>
        <li>Психоэндокринология и стресс-менеджмент</li>
      </ul>
      <p>
        Программа включает как теоретическую подготовку, так и практику в клиниках, диагностических центрах, лабораториях и
        исследовательских институтах.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Врач-эндокринолог в государственных и частных клиниках</li>
        <li>Специалист по метаболическим расстройствам</li>
        <li>Медицинский консультант в фитнес- и wellness-центрах</li>
        <li>Научный сотрудник в области гормональных исследований</li>
        <li>Специалист в фармацевтической компании (эндокринологические препараты)</li>
        <li>Преподаватель и исследователь (академическая карьера)</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€60,000 до €100,000 в год</strong>
      </p>
      <p>Спрос на эндокринологов постоянно растет, особенно с учётом глобального роста числа заболеваний, связанных с образом жизни.</p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с международным признанием</li>
        <li>Гибкая форма обучения: очно или дистанционно</li>
        <li>Современное оборудование и симуляционные технологии</li>
        <li>Практика и стажировки в клиниках ЕС</li>
        <li>Преподавание на английском или русском языке</li>
        <li>Персональное сопровождение студента на всех этапах обучения</li>
      </ul>
      <h2>Учёба, приближенная к практике</h2>
      <p>
        Наши студенты активно участвуют в профессиональных конференциях, стажируются в зарубежных учреждениях и работают с современными
        клиническими случаями.
      </p>
      <p>Мы готовим специалистов, которые способны не только лечить, но и менять жизнь своих пациентов к лучшему.</p>
      <br />
      <p className="padding-left">
        «Эндокринология — это искусство находить и восстанавливать баланс. Мы учим видеть не просто симптомы, а целостную картину здоровья
        человека.»
      </p>
      <h2>Как поступить?</h2>
      <p>
        Процесс поступления прост и прозрачен. Заполните анкету на сайте, загрузите документы и дождитесь обратной связи от приёмной
        комиссии. Мы сопровождаем каждого кандидата на всех этапах — от подачи заявки до начала учёбы.
      </p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра, магистра
    Форма обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии

    Эндокринология — образование, которое восстанавливает баланс жизни
    Эндокринология — это ключевое направление медицины, изучающее работу гормональной системы человека.
    Специалисты в этой области помогают людям с диабетом, ожирением, нарушениями щитовидной железы, репродуктивными и метаболическими расстройствами.
    Обучаясь на факультете медицины по направлению "Эндокринология", вы получаете как фундаментальные медицинские знания, так и специализированную подготовку, необходимую для диагностики, профилактики и лечения эндокринных заболеваний.

    Что вы будете изучать?
    Физиология и патология эндокринной системы
    Диабетология и ожирение
    Гормональные исследования и лабораторная диагностика
    Медицинская генетика и молекулярная биология
    Лечение метаболических синдромов
    Иммунология и аутоиммунные процессы
    Клиническая фармакология гормональных препаратов
    Психоэндокринология и стресс-менеджмент
    Программа включает как теоретическую подготовку, так и практику в клиниках, диагностических центрах, лабораториях и исследовательских институтах.

    Кем можно работать после окончания?
    Врач-эндокринолог в государственных и частных клиниках
    Специалист по метаболическим расстройствам
    Медицинский консультант в фитнес- и wellness-центрах
    Научный сотрудник в области гормональных исследований
    Специалист в фармацевтической компании (эндокринологические препараты)
    Преподаватель и исследователь (академическая карьера)

    Зарплата в Европе:
    от €60,000 до €100,000 в год
    Спрос на эндокринологов постоянно растет, особенно с учётом глобального роста числа заболеваний, связанных с образом жизни.

    Почему выбирают нас?
    Европейский диплом с международным признанием
    Гибкая форма обучения: очно или дистанционно
    Современное оборудование и симуляционные технологии
    Практика и стажировки в клиниках ЕС
    Преподавание на английском или русском языке
    Персональное сопровождение студента на всех этапах обучения

    Учёба, приближенная к реальной практике
    Наши студенты активно участвуют в профессиональных конференциях, стажируются в зарубежных учреждениях и работают с современными клиническими случаями.
    Мы готовим специалистов, которые способны не только лечить, но и менять жизнь своих пациентов к лучшему.
    «Эндокринология — это искусство находить и восстанавливать баланс. Мы учим видеть не просто симптомы, а целостную картину здоровья человека.»

    Как поступить?
    Процесс поступления прост и прозрачен. Заполните анкету на сайте, загрузите документы и дождитесь обратной связи от приёмной комиссии. Мы сопровождаем каждого кандидата на всех этапах — от подачи заявки до начала учёбы.
  `,
};
